export function isDefined<T>(value: T): boolean {
  return !(value === null || value === undefined);
}
